import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SocialLinkedin = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26 28H24C22.897 28 22 27.103 22 26V20.068C22 19.513 21.77 18.968 21.369 18.574C20.984 18.196 20.487 17.992 19.965 18.001C18.881 18.019 18 18.916 18 20.001V26.001C18 27.104 17.103 28.001 16 28.001H14C12.897 28.001 12 27.104 12 26.001V14.001C12 12.898 12.897 12.001 14 12.001H16C16.488 12.001 16.942 12.175 17.294 12.473C18.198 12.145 19.143 11.988 20.124 12.002C24.467 12.068 28 15.704 28 20.107V26.001C28 27.104 27.103 28.001 26 28.001V28ZM19.999 16C21.035 16 22.017 16.406 22.771 17.148C23.552 17.916 24 18.98 24 20.068V26H26V20.106C26 16.789 23.351 14.001 20.093 14.001C17.5 14.001 16 15.5 16 15.5V14H14V26H16V20C16 17.831 17.764 16.037 19.932 16.001C19.954 16.001 19.977 16.001 19.999 16.001V16Z" />
		<path d="M8 28H6C4.897 28 4 27.103 4 26V14C4 12.897 4.897 12 6 12H8C9.103 12 10 12.897 10 14V26C10 27.103 9.103 28 8 28ZM6 14V26H8C8.001 26 8.001 26 8.001 26L8 14H6V14Z" />
		<path d="M7 10C5.346 10 4 8.654 4 7C4 5.346 5.346 4 7 4C8.654 4 10 5.346 10 7C10 8.654 8.654 10 7 10ZM7 6C6.449 6 6 6.449 6 7C6 7.551 6.449 8 7 8C7.551 8 8 7.551 8 7C8 6.449 7.551 6 7 6Z" />
	</svg>
);

export default SocialLinkedin;
